import Vue from "vue";

export default {
  handleSizeChangeTalentRequisition({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    dispatch("getAllTalentRequisition");
  },
  handleCurrentChangeTalentRequisition({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getAllTalentRequisition");
  },
  // Create a new talent requisition
  createTalentRequisition({ commit }, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/recruitment/job-requests`, params)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
          commit("tableLoading", false);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
          commit("tableLoading", false);
        });
    });
  },

  // Update an existing talent requisition by ID
  updateTalentRequisition(_, { id, data }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/recruitment/job-requests/${id}`, data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Get a talent requisition by ID
  getTalentRequisitionById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/recruitment/job-requests/${id}`)
        .then(response => {
          commit("setSelectedRow", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Get all talent requisition
  getAllTalentRequisition({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);
      const params = {
        page: state.currentPage,
        per_page: state.perPage,
        ...(payload && payload),
      };
      Vue.$http
        .get("/hrm/recruitment/job-requests", { params })
        .then(response => {
          commit("talentRequisitions", response.data.results);
          commit("paginationTotal", response.data.total);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  // Delete a talent requisition by ID
  deleteTalentRequisition(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/hrm/recruitment/job-requests/${id}`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Approve a talent requisition by ID
  approveTalentRequisition(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/recruitment/job-requests/${id}/approve`, {})
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Reject a talent requisition by ID
  rejectTalentRequisition(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/recruitment/job-requests/${id}/reject`, {})
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Cancel a talent requisition by ID
  cancelTalentRequisition(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/recruitment/job-requests/${id}/cancel`, {})
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Reopen a talent requisition by ID
  reopenTalentRequisition(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/recruitment/job-requests/${id}/reopen`, {})
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
